(function () {
  'use strict';

  angular.module('app').component('creditNoteRelatedTransactions', creditNoteRelatedTransactions());

  function creditNoteRelatedTransactions() {
    return {
      bindings: {
        creditNote: '<',
        clientId: '<',
      },
      controller: CreditNoteRelatedTransactionsComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/credit-notes/components/credit-note-related-transactions/' +
        'credit-note-related-transactions.component.html',
    };
  }

  CreditNoteRelatedTransactionsComponent.$inject = [
    'CreditNoteService',
    'RelatedTransactionService',
  ];

  function CreditNoteRelatedTransactionsComponent(CreditNoteService, RelatedTransactionService) {
    let vm = this;

    // Methods
    vm.selectTransaction = selectTransaction;
    vm.openRelatedTransactionModal = openRelatedTransactionModal;

    vm.$onInit = function () {
      getRelatedTransactions();
    };

    function getRelatedTransactions() {
      vm.loadingRelatedTransactions = true;
      CreditNoteService.getRelatedTransactions(vm.creditNote.id, vm.clientId).then(function (data) {
        vm.invoice = data.invoice.invoice;
        vm.bookings = data.bookings;
        vm.creditNotes = data.invoice.data.creditNotes;
        vm.debitNotes = data.invoice.data.debitNotes;

        vm.creditNotes.forEach((creditNote) => {
          creditNote.invoice = angular.copy(vm.invoice);
          creditNote.bookings = data.bookings.length > 0 ? angular.copy(vm.bookings) : [];
        });

        if (data.invoice.data.receivedPayments.length > 0) {
          vm.receivedPayments = data.invoice.data.receivedPayments;
        }

        vm.loadingRelatedTransactions = false;
      });
    }

    function selectTransaction(transaction, index) {
      vm.transactionSelected = transaction;
      transaction.show = !transaction.show;

      if (index !== undefined) {
        vm.indexSelected = index;
      }
    }

    function openRelatedTransactionModal(transaction) {
      RelatedTransactionService.openRelatedTransactionModal(transaction);
    }
  }
})();
